
    <div class="login-header">
        <div class="title">{{appInfo.title}}</div>
        <div>Signed by entraID</div>
    </div>

